import { grey } from "@mui/material/colors";
import { RowClassParams } from "ag-grid-community";
import {
  agGridFooterColId,
  agGridGrandFooterColId,
} from "@/components/pages/common/ag-grid/utils/constants/agCommon";
import { agGridOverwrittenIcons } from "@/components/pages/common/ag-grid/utils/constants/agGridOverwrittenIcons";

export const hierarchyAllItemsGridDefaultColDef = {
  sortable: true,
  unSortIcon: true,
  filter: "agMultiColumnFilter",
  minWidth: 150,
  maxWidth: 700,
  flex: 10,
};

export const hierarchyAllItemsGridWrapperStyles = {
  ".my-default-expand-icon": { display: "none" },
  ".ag-row-hover .my-default-expand-icon": { display: "block" },
  ".ag-row-hover .my-custom-expand-icon": { display: "none" },
  " .ag-group-expanded, .ag-group-contracted ": {
    mr: 1,
    height: 24,
    width: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    p: 1.25,
    "&:hover": { background: grey[300] },
  },
  ".ag-row-group-indent-1": {
    pl: 0,
  },
  ".ag-row-group-indent-0": {
    ml: 0,
  },
  [`[row-id*="${agGridFooterColId}"]`]: {
    "& :hover": {
      bgcolor: "white",
    },
  },
  [`[row-id*="${agGridGrandFooterColId}"]`]: {
    border: 0,
  },
  [`[row-id*="${agGridFooterColId}"] .ag-cell`]: {
    bgcolor: "white",
  },
  ' .ag-row.last-row [col-id="actions"]': {
    border: "none !important",
  },
};

export const getHierarchyAllItemsRowClass = (params: RowClassParams) => {
  const isLastRow =
    params.node.rowIndex === params.api.getDisplayedRowCount() - 1;
  return isLastRow ? "last-row" : "";
};

export const hierarchyAllItemsGridIcons = {
  groupExpanded: `
            <div style="display: flex; align-items: center; justify-content: center;">
              ${agGridOverwrittenIcons.groupExpanded}
              <svg class="my-custom-expand-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.6415 4.99967L9.30817 6.66634H16.6665V14.9997H3.33317V4.99967H7.6415ZM8.33317 3.33301H3.33317C2.4165 3.33301 1.67484 4.08301 1.67484 4.99967L1.6665 14.9997C1.6665 15.9163 2.4165 16.6663 3.33317 16.6663H16.6665C17.5832 16.6663 18.3332 15.9163 18.3332 14.9997V6.66634C18.3332 5.74967 17.5832 4.99967 16.6665 4.99967H9.99984L8.33317 3.33301Z" fill="black" fill-opacity="0.87"/>
              </svg>
            </div>
          `,
  groupContracted: `
            <div style="display: flex; align-items: center; justify-content: center;">
              ${agGridOverwrittenIcons.groupContracted}
              <svg class="my-custom-expand-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.6415 4.99967L9.30817 6.66634H16.6665V14.9997H3.33317V4.99967H7.6415ZM8.33317 3.33301H3.33317C2.4165 3.33301 1.67484 4.08301 1.67484 4.99967L1.6665 14.9997C1.6665 15.9163 2.4165 16.6663 3.33317 16.6663H16.6665C17.5832 16.6663 18.3332 15.9163 18.3332 14.9997V6.66634C18.3332 5.74967 17.5832 4.99967 16.6665 4.99967H9.99984L8.33317 3.33301Z" fill="black" fill-opacity="0.87"/>
              </svg>
            </div>
          `,
};
